module.exports = __webpack_public_path__ + "static/img/result_list.2742e293.png";